var map = {
	"./pages-de.json": 225,
	"./pages-en.json": 226,
	"./pages-es.json": 227,
	"./pages-ja.json": 228,
	"./pages-ko.json": 229
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 522;
module.exports = webpackAsyncContext;